"use strict";

function populateSlidesOnMouseTouchMove(state, props, initialX, lastX, clientX, transformPlaceHolder) {
  var direction,
    nextPosition,
    itemWidth = state.itemWidth,
    slidesToShow = state.slidesToShow,
    totalItems = state.totalItems,
    currentSlide = state.currentSlide,
    infinite = props.infinite,
    canContinue = !1,
    slidesHavePassedRight = Math.round((initialX - lastX) / itemWidth),
    slidesHavePassedLeft = Math.round((lastX - initialX) / itemWidth),
    isMovingLeft = initialX < clientX;
  if (clientX < initialX && !!(slidesHavePassedRight <= slidesToShow)) {
    direction = "right";
    var translateXLimit = Math.abs(-itemWidth * (totalItems - slidesToShow)),
      nextTranslate = transformPlaceHolder - (lastX - clientX),
      isLastSlide = currentSlide === totalItems - slidesToShow;
    (Math.abs(nextTranslate) <= translateXLimit || isLastSlide && infinite) && (nextPosition = nextTranslate, canContinue = !0);
  }
  isMovingLeft && slidesHavePassedLeft <= slidesToShow && (direction = "left", ((nextTranslate = transformPlaceHolder + (clientX - lastX)) <= 0 || 0 === currentSlide && infinite) && (canContinue = !0, nextPosition = nextTranslate));
  return {
    direction: direction,
    nextPosition: nextPosition,
    canContinue: canContinue
  };
}
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.populateSlidesOnMouseTouchMove = populateSlidesOnMouseTouchMove;